@import '@hevoio/hevo-ui-toolkit/styles/variables';

.iframeContainer {
  height: 100%;
  background-color:  $secondary-bg;
  border-left: solid $border-width $divider-color;
  overflow: hidden;
  &.backdrop::after {
    content: ' ';
    background: var(--surface-bg-60-color);
    position: absolute;
    height: 100%;
    width: 100%;
    padding: $spacer * 0.65 0px;
    top: 0;
    left: 0;
    z-index: 4;
  }
}
